import { render, staticRenderFns } from "./AddPPMnew.vue?vue&type=template&id=0f5a0508&scoped=true&"
import script from "./AddPPMnew.vue?vue&type=script&lang=ts&"
export * from "./AddPPMnew.vue?vue&type=script&lang=ts&"
import style0 from "./AddPPMnew.vue?vue&type=style&index=0&id=0f5a0508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a0508",
  null
  
)

component.options.__file = "AddPPMnew.vue"
export default component.exports